let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aHZse")).then(() => parcelRequire('ax5Nk'));